import { store } from "../containers/Root";
import { openConfirm } from "../redux/actions/ui";

export function confirm(id, message) {
  return new Promise(function (resolve, reject) {
    store.dispatch(openConfirm(resolve, reject, message, id));
  });
}
